var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunnelStick2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 12,
    viewBox: "0 0 122 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.5 5.83235C110.5 2.79553 112.962 0.333253 115.999 0.333252C119.038 0.333252 121.5 2.79553 121.5 5.83234C121.5 8.87098 119.038 11.3333 115.999 11.3333C112.962 11.3333 110.5 8.87098 110.5 5.83235Z",
    fill: "#1254B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499992 5.33326L118.5 5.33325L118.5 6.33325L0.499992 6.33326L0.499992 5.33326Z",
    fill: "#1254B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnelStick2);
export default __webpack_public_path__ + "static/media/funnelStick2.7e5f7ba61255489c97882b88efd65c0d.svg";
export { ForwardRef as ReactComponent };